$(document).foundation();

/**
 * ### Attributes:
 * `animated-curve` : the initializer attribute that marks an element as the container.
 *
 * `origin` : the preferred image direction <left | right>
 *
 * `offset-x & offset-y` (optional) : controls the offset of the inner element relative to the container size. Values range from -1.0 to 1.0.
 *
 * `bottom` (optional, defaults to 200) : controls when from the bottom (in pixels) should the inner element begin animating in.
 *
 * `height` (optional, defaults to boundingClientRect) : controls the computed height of the element, which is used to calculate width.
 *
 * `rotate` (option) : Rotates the image around the Z axis.
 *
 * `<direction>-<direction>-rotate` (optional alternative) : Same as `rotate`, but is dependant to the current direction.
 *
 * ### Notes:
 * - The inner element (selected by `.inner`) will be added automatically if it does not already exist.
 * - Offsets will be updated on screen resize.
 */
class AnimatedCurveController {
    static update() {
        $("[animated-curve]").each((_index, element) => {
            let { bottom, height } = element.getBoundingClientRect();

            if (element.hasAttribute("height")) {
                height = parseInt(element.getAttribute("height"));
            }

            const startBottom = element.hasAttribute("bottom") ? parseInt(element.getAttribute("bottom")) : 200;
            const progress = (1 / height) * Math.min(Math.max(-(bottom - innerHeight) - startBottom + height, 0), height);

            $(element).find(".inner").css("width", `${progress * 100}%`);
        });
    }

    static updateOffset() {
        $("[animated-curve]").each((_index, element) => {
            const self = $(element);

            const { width, height } = element.getBoundingClientRect();
            const x = element.hasAttribute("offset-x") ? parseFloat(element.getAttribute("offset-x")) : 0;
            const y = element.hasAttribute("offset-y") ? parseFloat(element.getAttribute("offset-y")) : 0;
            let conditionalRotate = null;

            for (let a of ["Left", "Right", "Vertical", "Horizontal"]) {
                for (let b of ["Left", "Right", "Vertical", "Horizontal"]) {
                    conditionalRotate = self.hasClass(a) && self.hasClass(b) ? (element.getAttribute(`${a.toLowerCase()}-${b.toLowerCase()}-rotate`) || conditionalRotate) : conditionalRotate;
                }
            }

            self.find(".inner").css("transform", `translate(${x * width}px, ${y * height}px) rotate(${conditionalRotate || element.getAttribute("rotate") || "0"})`);
        });
    }

    static init() {
        $(document).on("scroll", () => this.update());
        $(window).on("resize", () => this.updateOffset());

        $("[animated-curve]").each((_index, element) => {
            const self = $(element);

            if (self.find(".inner").length < 1) {
                self.append(`<div class="inner"></div>`);
            }
        });

        this.updateOffset();
        this.update();
    }
}

window.addEventListener('DOMContentLoaded',() => {
    const pageElements = document.querySelectorAll('[animate]');
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            entry.isIntersecting && entry.target.classList.add('in-view');
        });
    });
    pageElements.forEach(element => {
        observer.observe(element);
    });    
});

$(document).ready(function() {

    var trigger_event = $('.trigger-event');

    if(trigger_event.length > 0 ){
        trigger_event.trigger('click');
    }

    $(document).on('click', '#btn-flyout-menu', function() {
        $('body').addClass('menu-open');
        $('#flyout-menu').addClass('open');
    });
    $(document).on('click', '.btn-close-flyout', function() {
        $('body').removeClass('menu-open');
        $('#flyout-menu').addClass('close');
        setTimeout(function() {
            $('#flyout-menu').removeClass('open close');
        }, 400);
    });

    $(".elements__herocarousel").each((_index, element) => {
        let direction = "right";

        const self = $(element);
        const slider = self.find(".image-carousel");
        const count = slider.data('count');
        const autoplay = slider.data('autoplay');
        const autoplaySpeed = slider.data('autoplay-speed');
        const showDots = count > 1 ? true : false;
        const prev = self.find('.slide-prev');
        const next = self.find('.slide-next');
        const mainCarousel = slider.slick({
            fade: true,
            arrows: true,
            dots: showDots,
            swipe: false,
            prevArrow: prev,
            nextArrow: next,
            autoplay: autoplay,
            autoplaySpeed: autoplaySpeed,
            pauseOnHover: false,
        });
    });

    if ($('.calendar-slider').length > 0) {

        $('.calendar-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
            $('.slide-bar').removeClass('active');
            $('.cal-slide-bars').find('.slide-bar').eq(nextSlide).addClass('active');
        });

        $('.calendar-slider').slick({
            fade: false,
            dots: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            prevArrow: $('.calendar-slider-prev'),
            nextArrow: $('.calendar-slider-next'),
            infinite: true,
            appendDots: '.calendar-slider-nav',
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                  }
                },
                {
                  breakpoint: 640,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                  }
                }
            ]
        });
    }

    if ($('.photo-slider').length > 0) {

        $('.photo-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
            $('.slide-bar').removeClass('active');
            $('.cal-slide-bars').find('.slide-bar').eq(nextSlide).addClass('active');
        });

        $('.photo-slider').slick({
            fade: false,
            dots: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            prevArrow: $('.photo-slider-prev'),
            nextArrow: $('.photo-slider-next'),
            infinite: true,
            appendDots: '.photo-slider-nav',
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                  }
                },
                {
                  breakpoint: 640,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true
                  }
                }
            ]
        });
    }

    $('.awards-carousel').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        arrows:true,
        dots:true,
        prevArrow:'<a class="slider-prev"><i class="fal fa-chevron-left"></i></a>',
        nextArrow:'<a class="slider-next"><i class="fal fa-chevron-right"></i></a>',
    });

    $(document).on('click', '.camp-nav-link', function(e){
        var self = $(this),
            section = self.data('section');

            console.log(section);

        // Scroll to this section
        $('html, body').animate({
            scrollTop: $(section).offset().top - 153
        }, 1000);


        e.preventDefault();
    });


    $(document).on('click', '#btn-load-camp-tiles', function(e){
        var self = $(this),
            page = parseInt(self.data('page')),
            url = `/ajax/camps/${page}`,
            holder = $('#camps-grid');

        $.ajax({
            type: "GET",
            url: url,
            cache: false,
         })
        .done(function (data) {
            holder.append(data);
            self.data('page', page+1);
            // self.remove();
        })
        .fail (function (xhr) {
        });

        e.preventDefault();
    });

    AnimatedCurveController.init();

    if ($(document.body).hasClass("Blog")) {
        BlogController.init();
    }

    $(".dynamic__elements__gallery__elements__elementphotogallery").each((_index, element) => {
        const self = $(element);
        const slider = self.find(".gallery-slider");
        if (slider.length) {
            const mainCarousel = slider.slick({
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                autoplay:false,
                dots: true,
                adaptiveHeight:true,
                prevArrow:'<a class="slider-prev"><i class="fal fa-chevron-left"></i></a>',
                nextArrow:'<a class="slider-next"><i class="fal fa-chevron-right"></i></a>',
                responsive: [
                  {
                    breakpoint: 640,
                    settings: {
                        arrows: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode:true
                    }
                  },
                ]
            });
        }
    });


    // Instagram Slider
    $(".elements__instagramfeedelement").each((_index, element) => {
        let direction = "right";

        const self = $(element);
        const prev = self.find('.slide-prev');
        const next = self.find('.slide-next');
        const mainCarousel = self.find(".ig-feed").slick({
            mobileFirst: true,
            fade: false,
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: prev,
            nextArrow: next,
            infinite: false,
            responsive: [
                {
                  breakpoint: 640,
                  settings: {
                      slidesToShow: 2,
                      slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 1024,
                  settings: 'unslick'
                }
            ]
        });
    });

    $(window).on('resize', function() {
        // if (false) {
        //     $('.ig-feed').slick('resize');
        // }
    });

    if($('.HomePage').length) {
        // grecaptcha.ready(function() {
        //     grecaptcha.execute('6Lcx2toUAAAAAMsdYezqnFHC3kmnuwjNDh-RxtNt', {action: 'homepage'}).then(function(token) {
        //         //
        //     });
        // });
    }

    if($('.CapitalCampaignPage').length) {

        $(document).on('click', '.tile', function(e){
            var projectID = $(this).data('id');
            $(".project").slideUp();
            $("#project"+projectID).slideDown(700);
        });

        var currentIndex = 1;
        function fadeImages() {
            if (currentIndex == 1){
                $("#steamrightimage1").fadeOut(400);
                $("#steamrightimage2").fadeIn(700);
                $("#steamleftimage1").fadeOut(400);
                $("#steamleftimage2").fadeIn(700);

                $("#amountleft1").fadeOut(400);
                $("#amountleft2").fadeIn(700);
                $("#amountright1").fadeOut(400);
                $("#amountright2").fadeIn(700);
            }
            if (currentIndex == 2){
                $("#steamrightimage2").fadeOut(400);
                $("#steamrightimage3").fadeIn(700);
                $("#steamleftimage2").fadeOut(400);
                $("#steamleftimage3").fadeIn(700);

                $("#amountleft2").fadeOut(400);
                $("#amountleft3").fadeIn(700);
                $("#amountright2").fadeOut(400);
                $("#amountright3").fadeIn(700);
            }
            if (currentIndex == 3){
                $("#steamrightimage3").fadeOut(400);
                $("#steamrightimage1").fadeIn(700);
                $("#steamleftimage3").fadeOut(400);
                $("#steamleftimage1").fadeIn(700);


                $("#amountleft3").fadeOut(400);
                $("#amountleft1").fadeIn(700);
                $("#amountright3").fadeOut(400);
                $("#amountright1").fadeIn(700);
            }

            currentIndex++;
            if (currentIndex == 4){
                currentIndex = 1;
            }
        }
        fadeImages();
        setInterval(fadeImages, 5000);


        function startCountingWhenVisible(entries, observer) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    startCounting();
                    observer.unobserve(entry.target); // Stop observing once element is visible
                }
            });
        }
        
        function startCounting() {
            var counterElement = $('#countUpVal');
            var targetNumber =   $('#countUpVal').data('to');
            var duration = 3500; 
            var interval = 10;
            var currentNumber = 0;
            var increment = targetNumber / (duration / interval);
            var timer = setInterval(function() {
                currentNumber += increment;
                if (currentNumber >= targetNumber) {
                    currentNumber = targetNumber;
                    clearInterval(timer);
                }
                counterElement.html(Math.round(currentNumber).toLocaleString());
            }, interval);
        }
        
        var observer = new IntersectionObserver(startCountingWhenVisible, { threshold: 0.5 });
        var counterElement = document.getElementById('countUpVal');
        observer.observe(counterElement);

        var currentSlide = 1;
        $(document).on('click', '.slider-next', function(e){
            currentSlide++;
            if(currentSlide>3){
                currentSlide = 1;
            }

            $(".slider-item").removeClass('active');
            $("#slider-item"+currentSlide).addClass('active');
        });
        $(document).on('click', '.slider-prev', function(e){
            currentSlide--;
            if(currentSlide<1){
                currentSlide = 3;
            }

            $(".slider-item").removeClass('active');
            $("#slider-item"+currentSlide).addClass('active');
        });





        var currentWave1Index = 1;
        function fadeWaveImages1() {
            if (currentWave1Index == 1){
                $("#wave1pic1").fadeOut(2000);
                $("#wave1pic2").fadeIn(2000);

                $("#wave2pic1").delay(500).fadeOut(2000);
                $("#wave2pic2").delay(500).fadeIn(2000);

                $("#wave3pic1").delay(1000).fadeOut(2000);
                $("#wave3pic2").delay(1000).fadeIn(2000);

                $("#wave4pic1").delay(1500).fadeOut(2000);
                $("#wave4pic2").delay(1500).fadeIn(2000);
            }
            if (currentWave1Index == 2){
                $("#wave1pic2").fadeOut(2000);
                $("#wave1pic3").fadeIn(2000);

                $("#wave2pic2").delay(500).fadeOut(2000);
                $("#wave2pic3").delay(500).fadeIn(2000);

                $("#wave3pic2").delay(1000).fadeOut(2000);
                $("#wave3pic3").delay(1000).fadeIn(2000);

                $("#wave4pic2").delay(1500).fadeOut(2000);
                $("#wave4pic3").delay(1500).fadeIn(2000);
            }
            if (currentWave1Index == 3){
                $("#wave1pic3").fadeOut(2000);
                $("#wave1pic1").fadeIn(2000);

                $("#wave2pic3").delay(500).fadeOut(2000);
                $("#wave2pic1").delay(500).fadeIn(2000);

                $("#wave3pic3").delay(1000).fadeOut(2000);
                $("#wave3pic1").delay(1000).fadeIn(2000);

                $("#wave4pic3").delay(1500).fadeOut(2000);
                $("#wave4pic1").delay(1500).fadeIn(2000);
            }
            currentWave1Index++;
            if (currentWave1Index == 4){
                currentWave1Index = 1;
            }
        }
        setInterval(fadeWaveImages1, 5000);

        // var currentWave2Index = 1;
        // function fadeWaveImages2() {
        //     if (currentWave2Index == 1){
        //         $("#wave2pic1").fadeOut(1000);
        //         $("#wave2pic2").fadeIn();
        //     }
        //     if (currentWave2Index == 2){
        //         $("#wave2pic2").fadeOut(1000);
        //         $("#wave2pic3").fadeIn();
        //     }
        //     if (currentWave2Index == 3){
        //         $("#wave2pic3").fadeOut(1000);
        //         $("#wave2pic1").fadeIn();
        //     }
        //     currentWave2Index++;
        //     if (currentWave2Index == 4){
        //         currentWave2Index = 1;
        //     }
        // }
        // setInterval(fadeWaveImages2, 4500);


        // var currentWave3Index = 1;
        // function fadeWaveImages3() {
        //     if (currentWave3Index == 1){
        //         $("#wave3pic1").fadeOut(1000);
        //         $("#wave3pic2").fadeIn();
        //     }
        //     if (currentWave3Index == 2){
        //         $("#wave3pic2").fadeOut(1000);
        //         $("#wave3pic3").fadeIn();
        //     }
        //     if (currentWave3Index == 3){
        //         $("#wave3pic3").fadeOut(1000);
        //         $("#wave3pic1").fadeIn();
        //     }
        //     currentWave3Index++;
        //     if (currentWave3Index == 4){
        //         currentWave3Index = 1;
        //     }
        // }
        // setInterval(fadeWaveImages3, 4750);


        // var currentWave4Index = 1;
        // function fadeWaveImages4() {
        //     if (currentWave4Index == 1){
        //         $("#wave4pic1").fadeOut(1000);
        //         $("#wave4pic2").fadeIn();
        //     }
        //     if (currentWave4Index == 2){
        //         $("#wave4pic2").fadeOut(1000);
        //         $("#wave4pic3").fadeIn();
        //     }
        //     if (currentWave4Index == 3){
        //         $("#wave4pic3").fadeOut(1000);
        //         $("#wave4pic1").fadeIn();
        //     }
        //     currentWave4Index++;
        //     if (currentWave4Index == 4){
        //         currentWave4Index = 1;
        //     }
        // }
        // setInterval(fadeWaveImages4, 5000);


    }//End CapitalCampaignPage
    

    $('.tile-slider').each(function() {
        var grid = $(this);
        var count = grid.data('count');
        var prevArrow = grid.parent().find('.tile-prev-slide');
        var nextArrow = grid.parent().find('.tile-next-slide');
        grid.slick({
            infinite: true,
            slidesToShow: count,
            slidesToScroll: 1,
            centerMode: false,
            arrows:true,
            dots:false,
            prevArrow:prevArrow,
            nextArrow:nextArrow,
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                  }
              },
                {
                  breakpoint: 700,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                  }
                }
            ]
        });
    });

    $('.content-slider').each(function() {
        var grid = $(this);
        var prevArrow = grid.parent().find('.slider-prev');
        var nextArrow = grid.parent().find('.slider-next');
        grid.slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            arrows:true,
            dots:true,
            prevArrow:prevArrow,
            nextArrow:nextArrow,
        });
    });

    // $('#related-posts-slider').slick({
    //     infinite: true,
    //     slidesToShow: 3,
    //     slidesToScroll: 1,
    //     centerMode: false,
    //     arrows:true,
    //     dots:true
    // });

});



// $('.cal-slide-bars').slick({
//     infinite: false,
//     arrows: false,
//     fade: true,
//     dots: false,
//     asNavFor: '.calendar-slider'
// });

$(document).on('click', '.calendar-categories.expands h3', function(e){

    var self = $(this),
        holder = self.parent('.calendar-categories');

    holder.toggleClass('expanded');

    e.preventDefault();

});

$(document).on('click', '.close-reveal-calendar', function(e){
    $('.reveal-added').foundation('close');

    window.history.pushState('calendar', 'Calendar', '/calendar');

});

$(document).on('click', '.calendar-event-ajax-link', function(e){

    var self = $(this),
        title = self.attr('title'),
        href = self.attr('href');

    var reveal = $('#dynamic-reveal'),
        loader = '<div class="text-center"><i class="fal fa-spinner fa-spin"></i></div>';

    if(reveal.length > 0){
        reveal.html(loader);
    }else{
        reveal = $('<div/>', {id: 'dynamic-reveal', class:'reveal reveal-added', 'data-reveal':'', html:loader}).appendTo('body');

        Foundation.reflow($('.reveal-added'), 'reveal');
    }

    window.history.pushState('event', title, href);

    $.ajax({
        type: "GET",
        url: href,
        dataType: 'json',
        cache: false,
        data: {}
     })
    .done(function (data) {
        reveal.addClass('calendar-event-reveal');
        reveal.html(data.output).foundation('open');
    })
    .fail (function (xhr) {
    });


    e.preventDefault();
});



function getUrlParams(url) {
    var params = {};
    url.substring(1).replace(/[?&]+([^=&]+)=([^&]*)/gi,
            function (str, key, value) {
                 params[key] = value;
            });
    return params;
}


$(document).on('click', '.calendar-ajax-link:not(.disabled)', function(e){

    $('#calendar-replace').addClass('loading').prepend('<i class="cal-loading fal fa-spinner fa-spin"></i>');
    var self = $(this),
        href = self.attr('href'),
        filter = $('#calendar-replace').data('filter');

    $('#calendar-replace').data('href', href);

    if(filter){
        href += '&'+filter;
        console.log(filter);
    }

    // href

    $.ajax({
        type: "GET",
        url: href,
        dataType: 'json',
        cache: false,
        data: {},
        beforeSend: function( xhr ) {
            //$('.loader-holder').addClass('visible');
        }
     })
    .done(function (data) {
        var title = data.title;
        $('#calendar-replace').html(data.output).removeClass('loading');
        $('#calendar-title').html(data.title);
        if (!$('body').hasClass('CalendarPage')) {
            $('.month-nav-link').removeClass('active');
            if (title.match(/May/)) {
                $('#month-nav-may').addClass('active');
            } else if (title.match(/June/)) {
                $('#month-nav-june').addClass('active');
            } else if (title.match(/July/)) {
                $('#month-nav-july').addClass('active');
            } else if (title.match(/August/)) {
                $('#month-nav-august').addClass('active');
            }
        }
    });

    if (self.hasClass('month-nav-link')) {
        $('.month-nav-link').removeClass('active');
        self.addClass('active');
    }

    e.preventDefault();
});

$(document).on('click', '.calendar-filter', function(e){
    var self = $(this);

    if(self.hasClass('type')){
        $('.calendar-filter.active').removeClass('active');
    }else{
        $('.calendar-filter.type.active').removeClass('active');
    }

    self.toggleClass('active');

    //var filter = self.data('filter');



    var filter = $.map($('.calendar-filter.active'), function(n, i){
          return $(n).data('filter');
    }).join('&');

    $('#calendar-replace').data('filter', filter);

    var url = '/calendar/filter?'+filter;

    var href = $('#calendar-replace').data('href');

    if(href){
        url = href + '&' + filter;
    }

    $.ajax({
        type: "GET",
        url: url,
        dataType: 'json',
        cache: false,
        data: {},
        beforeSend: function( xhr ) {
            //$('.loader-holder').addClass('visible');
        }
     })
    .done(function (data) {
        $('#calendar-replace').html(data.output);
    });

    e.preventDefault();
});

$('#contact-form').submit(function() {
    var form = $(this)
    var submitMessage = $(this).parent().find('.submit-message');
    grecaptcha.ready(function() {
        grecaptcha.execute('6Lcx2toUAAAAAMsdYezqnFHC3kmnuwjNDh-RxtNt', {action: 'contactform'}).then(function(token) {
            form.ajaxSubmit({
                beforeSerialize: function($form, options) {
                    $('#contact-form_CaptchaToken').val(token);
                },
                success: function(){
                    $('#contact-form').addClass('hide');
                    submitMessage.removeClass('hide');
                },
                error: function(e) {
                    console.log('form error: '+e)
                }
            });
        });
    });


    return false;
});


$(document).on('click', '.calendar-full-view-toggle', function(e){
    $('#calendar-replace').removeClass('list-view');
    e.preventDefault();
});

$(document).on('click', '.calendar-list-view-toggle', function(e){
    $('#calendar-replace').addClass('list-view');
    e.preventDefault();
});


$(document).on('click', '.calendar-filter-toggle', function(e){
    $('#calendar-categories-menu').toggleClass('visible');

    if($('#calendar-categories-menu').hasClass('visible')){

        var scrollPosition = window.pageYOffset;
        $('body').css({'top':  -scrollPosition + 'px'});
        $('body').addClass('calendar-no-scroll');

        var self = $(this),
            top = self.offset().top;

        $('#calendar-categories-menu').animate({top: 100});

        $('<div/>', {'class': 'hidden-mask'}).appendTo('body');
    }else{
        $('#calendar-categories-menu').animate({top: 1000});

        //window.scrollTo(0, scrollPosition);
        $('body').removeClass('calendar-no-scroll');
        var scrollPosition = window.pageYOffset;
        $('body').css({'top':  -scrollPosition + 'px'});
        $('.hidden-mask').remove();

    }
    e.preventDefault();
});

$(document).on('click', '.hidden-mask', function(e){
    $('.calendar-filter-toggle').trigger('click');
    e.preventDefault();
});

$( ".l2-link" )
  .mouseover(function() {
      var self = $(this);
      var id = self.attr('id');
      var imgUrl = self.data('bg');
      var bg = $('<div />', {
          id: id+'-bg',
          class: 'link-background',
          style: 'background-image:url('+imgUrl+')'
      });
      if ($(id+'-bg').length < 1) {
          if (imgUrl) {
              bg.prependTo('#flyout-menu').end().fadeIn('fast');
              // bg.attr('style', 'background-image:url('+imgUrl+');').fadeIn('fast', function() {
              //     $(this).addClass('active');
              // });
          }
      }
      // bg.prependTo('#flyout-menu').end().fadeIn('fast');
  })
  .mouseout(function(e) {
      $('.link-background').fadeOut('fast', function() {
          // more
      });
  });

    $( ".l1-item.parent" )
    .mouseover(function() {
        $('.menu-content').addClass('indent');
    })
    .mouseout(function(e) {
        $('.menu-content').removeClass('indent');
    });

    $(document).on('click','.l1-link.is-parent', function() {
        if (Foundation.MediaQuery.current == 'small') {
            var sub = $(this).parent().find('.sub-menu');
            // Fade Out all level 1 content
            $('#flyout-menu').addClass('mobile-sub-open');
            // Fade In Sub Menu
            setTimeout(function() {
                sub.fadeIn(200);
            }, 200);
            setTimeout(function() {
                sub.addClass('active');
                // Color Transition
                $('.btn-close-flyout').addClass('white');
            }, 400);
            return false;
        }
    });
    $(document).on('click','.back-link', function() {
        var sub = $(this).parents('.sub-menu');
        sub.removeClass('active').delay( 200 ).fadeOut(300);
        setTimeout(function() {
            $('#flyout-menu').removeClass('mobile-sub-open');
        }, 200);
        $('.btn-close-flyout').removeClass('white');
        return false;
    });

    $(document).on('click','[data-form-modal]', function() {
        var $modal = $('#form-modal');
        var url = $(this)[0].getAttribute("href");

        $.ajax(url).done(function(resp){
            var form = $(resp).find('form');
            $modal.find('#form-modal-inner').html(form).end().foundation('open');
        });
        return false;
    });

    if ($('body').hasClass('CampsCalendarPage')) {
        $('#month-nav-may').trigger('click');
        $('#calendar-page-holder').removeClass('temp-loading');
    }

    $(document).on('change','#subnav-mobile', function() {
        var select = $(this)[0];
        var url = select.value;
        var type = select.options[select.selectedIndex].dataset.type;
        if (type == 'external') {
            window.open(url, '_blank').focus();
            return false;
        }
        window.location = url;
        return false;
    });

    // $(window).scroll(function(e) {
//
//     if($('body').hasClass('calendar-no-scroll')){
//         return false;
//     }
//
// });

// $(document).on('touchend', '.calendar-no-scroll', function(e){
//     e.preventDefault();
// });

// targetElement.ontouchend = (e) => {
//     e.preventDefault();
// };
